import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import MatButton from '@mui/material/Button';
import MUIDataTable from "mui-datatables";
import { PDFExport} from "@progress/kendo-react-pdf";
import Moment from 'moment';

// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import PageTemplate from "Routes/pdfTemplate";



import {  
   
    allFindingChart,
    fetchFindingChart
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';



class mskfindingreport extends Component {
   
    constructor(props) {
      
        super(props);
            this.confirmationDialog = React.createRef();
            this.state = {
                viewdiv:true,
                succdiv:false,
                student:'',
                selectedFile:'',
            };  
        
        this.selectorRef = React.createRef(null);
        this.onBackSection = this.onBackSection.bind(this);
      
    }

    UNSAFE_componentWillMount() {
        this.props.allFindingChart('');
	}

    selectquarter(evt){
        var selstudent=evt.value;
        if(selstudent!=''){
            this.setState({ student : selstudent});
            this.props.getMskfindscreninglist(selstudent).then((data) => {   
                this.setState({ viewdiv : true});
            });
           
        }
    }

    addHandleReport(rowid){
        
        this.props.fetchFindingChart(rowid).then((data) => { 
                this.setState({ 
                    viewdiv:false,
                    errordiv:false,
                    succdiv:true 
                });  

        });
        
    }

    onAddSession() {
		this.setState({ 
         viewdiv:false,
         editdiv:false,
         adddiv:true
          });
	} 
    
    exportPDFWithMethod = () => {
        this.selectorRef.current.save();
    }

    onBackSection() {
		this.setState({ 
            succdiv:false,
            viewdiv:true,
         });
	}    

    render() {
       const { match,  findchartlists, findchartresponse, loading } = this.props;

        

       const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };

        const columns = [
            { name: "no", label: "No" },
            { name: "name", label: "Name" },
            { name: "date", label: "Date" },
            { name: "report", label: "Report" }
        ];
        const tabledata=findchartlists.map((assmntval,idx) => {            
            
                const ebtn=<MatButton variant="contained" color="error" className="btn-icon btn-google mr-15 mb-10 text-white" onClick={ ()=>this.addHandleReport(assmntval.sfcID)}> <i className="zmdi zmdi-file-text"></i> Report</MatButton>;
             
                return {
                no:idx+1,
                name: assmntval.student,
                date: assmntval.cdate,
                report: ebtn
                }
        });

        const formatDate = Moment(findchartresponse.sfc_date).format('DD/MM/YYYY   hh:mm a');

        const styles = {
            table: {
                border: "1px solid black",
                borderColor:"red",
                borderStyle:"solid",
                fontFamily: "Arial",            
                zIndex:"100"
            },
            tablelefthead:{
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "red",
                borderCollapase: "collapse",
                borderSpacing: "0px",
                whiteSpace: "pre-line",
                wordWrap: "break-word",            
                textAlign: "left",
                width:"30%",
                fontWeight:"bold",
                fontSize:"18px"
            },
            tabletrtd: {
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "red",
                borderCollapase: "collapse",
                borderSpacing: "0px",
                whiteSpace: "pre-line",
                wordWrap: "break-word",            
                textAlign: "left",
                fontSize:"16px"
            },
            rctcontent:{
            
                marginTop:"80px",
                borderRadius: "5px",
                boxShadow: "0 1px 15px 1px rgba(69, 65, 78, 0.08)",
                border: "none",
                transition: "all 0.4s ease-in-out 0s",
                marginBottom: "50px"
    
            }
        };
       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>MSK Screening Findings | {AppConfig.appTitle}</title>
                <meta name="description" content="Sport Science Team" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.mskfindscreenheading" />} match={match} />

                

                {this.state.viewdiv && 
                  <div className="col-sm-12 col-md-8">
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable                              
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>  
                } 

                {this.state.succdiv &&
                    
                    <div className="col-sm-12 col-md-8">   
                        <div className="example-config">
                            <button
                            className="mr-3 mb-3 btn btn-outline-primary"
                            onClick={this.exportPDFWithMethod}
                            >
                            Export PDF
                            </button>

                            <button
                            className="mr-3 mb-3 btn btn-outline-warning float-right"
                            onClick={this.onBackSection}
                            >
                            Back
                            </button>
                        
                        </div>
                        <PDFExport   
                            pageTemplate={PageTemplate}                    
                            scale={0.6}
                            paperSize="A4"
                            margin={{ top: "2.2cm", left: "1.5cm", right: "1.5cm", bottom: "1.5cm" }} 
                            fileName={`${findchartresponse.student} - MSK Screening Findings`}
                            ref={this.selectorRef}
                            forcePageBreak=".page-break" 
                            >  
                            <div style={styles.rctcontent}  >
                                <div className="collapse show">
                                    <div className="rct-block-content" style={{padding:"1.25rem 1.25rem"}}>
                                        <div className="row justify-content-center reportdiv">
                                            <h1 className="text-center" style={{marginTop:"80px", marginBottom:"50px"}}> MSK Screening Findings</h1>
                                            <table className="table align-items-center table-flush" style={styles.table}>                                            
                                                <tbody>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                        Name 
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                        {findchartresponse.student}
                                                    </td>                                                   
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                        Date and Time
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                    {formatDate}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                        Red Flags
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                    {findchartresponse.sfc_redflags}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                        Injury If any
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                    {findchartresponse.sfc_previousinjury}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                    Radiological Investigations Reports
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                    {findchartresponse.sfc_investigations}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                        Note For Coaching Team
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                    {findchartresponse.sfc_notes_coachteam}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                        Note for S&C Team
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                    {findchartresponse.sfc_notes_scteam}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={styles.tablelefthead}>
                                                     Note For Team TSG
                                                    </td>
                                                    <td style={styles.tabletrtd}>
                                                    {findchartresponse.sfc_notes_tsgteam}
                                                    </td>
                                                </tr>
                                                
                                                </tbody>
                                            </table>
                                            <div className="col-md-12" style={{marginTop:"80px"}}>
                                                <p style={{fontSize:"20px"}}>{findchartresponse.sc_name}</p>
                                                <p style={{whiteSpace:"pre-wrap",fontSize:"20px"}}>{findchartresponse.sc_designation}</p>
                                                <p style={{marginTop:"20px",fontSize:"20px", fontWeight:"300"}}>{'{e}'} {findchartresponse.sc_email}</p>
                                                <p style={{fontWeight:"300",fontSize:"20px"}}>{'{p} +91'} {findchartresponse.sc_phone}</p>
                                            </div>                                            
                                        </div>
                                    </div>
                                </div>        
                            </div> 
                        </PDFExport>
                    </div> 
                } 
               
            
          </div>
       )
    }
 }


const mapStateToProps = ({ findingchart }) => {
	const { findchartlists, findchartresponse, findingreportlists, loading } = findingchart;
	return { findchartlists, findchartresponse, findingreportlists, loading };
}

export default connect(mapStateToProps, {
    allFindingChart,
    fetchFindingChart
})(mskfindingreport); 